"use client"

import { Dialog, cn } from "@rarible_int/anaconda_ui_components"
import { type ComponentPropsWithoutRef, useEffect, useState } from "react"
import { GachaDialogContent } from "./gacha-dialog-content"
import {
  GACHA_DIALOG_FADE_MS,
  GACHA_RESULT_DIALOG_CONTENT_Z,
} from "./gacha-reveal-handoff"

type GachaResultDialogContentProps = ComponentPropsWithoutRef<
  typeof GachaDialogContent
> & {
  fadeIn?: boolean
}

export function GachaResultDialogContent({
  className,
  children,
  fadeIn = false,
  ...props
}: GachaResultDialogContentProps) {
  const [visible, setVisible] = useState(!fadeIn)

  useEffect(() => {
    if (!fadeIn) {
      setVisible(true)
      return
    }

    setVisible(false)
    const frame = window.requestAnimationFrame(() => {
      setVisible(true)
    })
    return () => window.cancelAnimationFrame(frame)
  }, [fadeIn])

  return (
    <GachaDialogContent
      className={cn(
        GACHA_RESULT_DIALOG_CONTENT_Z,
        "data-[state=open]:animate-none data-[state=closed]:animate-none transition-opacity ease-out",
        visible ? "opacity-100" : "opacity-0",
        className,
      )}
      style={{ transitionDuration: `${GACHA_DIALOG_FADE_MS}ms` }}
      {...props}
    >
      <div className="relative flex min-h-0 w-full flex-1 flex-col overflow-hidden">
        {children}
      </div>
    </GachaDialogContent>
  )
}

export { Dialog }
